import _ from 'lodash';
import englishScores from 'data/english.score.json';

const englishKeys = englishScores.map(({ key }) => key);
const englishFields = englishKeys.flatMap(key => [key, `${key}_exam_date`]);

const INITIAL_STATE = {
  user: {},
  folioUser: {},
  pendingTickets: [],
  courses: [],
  courseMap: {},
  admissionCountMap: {},
  coursesR1: [],
  courseMapR1: {},
  admissionRemoves: []
};

const appReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_USER':
      return { ...state, user: action.result };
    case 'UPDATE_FOLIO_USER':
      return { ...state, folioUser: action.result };
    case 'UPDATE_PROFILE_SCORES': {
      const fields = action.section === 'english' ? englishFields
        : action.section === 'chinese' ? ['hsk_level', 'hsk_score', 'hsk_exam_date'] : [];
      const patch = _.pick(action.result, fields);
      const mergeScores = user => ({
        ...user,
        ...patch,
        ...(action.section === 'english' ? { verified_scores: {
          ..._.omit(user?.verified_scores, englishKeys),
          ..._.pick(action.result?.verified_scores, englishKeys),
        } } : {}),
      });
      return { ...state, user: mergeScores(state.user),
        folioUser: _.isEmpty(state.folioUser) ? state.folioUser : mergeScores(state.folioUser) };
    }
    case 'UPDATE_PENDING_TICKETS':
      return { ...state, pendingTickets: action.tickets };
    case 'UPDATE_EDUCATION':
      return { ...state, education: action.result };
    case 'UPDATE_COURSES':
      return { ...state, courses: action.courses, courseMap: _.keyBy(action.courses, '_id') };
    case 'UPDATE_ADMISSION_COUNT_MAP':
      return { ...state, admissionCountMap: action.admissionCountMap };
    case 'UPDATE_COURSES_R1':
      const _courses = [{
        _id: '68e2a3481673f186a758b9f5',
        university_id: '999',
        university_name_th: 'ยังไม่ระบุสาขาวิชา'

      }].concat(action.courses);
      return {
        ...state,
        coursesR1: _courses,
        courseMapR1: _.keyBy(_courses, ({ program_id, major_id, project_id }) => `${program_id || 0}_${major_id || 0}_${project_id || 0}`)
      };
    case 'ADD_ADMISSION':
      return { ...state, admissionRemoves: (state.admissionRemoves || []).filter(_id => _id !== action.favoriteId) };
    case 'REMOVE_ADMISSION':
      return { ...state, admissionRemoves: (state.admissionRemoves || []).concat([action.favoriteId]) };
    case 'CLEAR_ADMISSION_REMOVES':
      return { ...state, admissionRemoves: [] };
    default:
      return state;
  }
};

export default appReducer;
